/**
 * Display (of the mode of simple or detailed) View
 * @author tbroussard
 *
 * This view is a handler for changing state of transaction collection's
 * display mode between simple and detailed.
 */
import BaseView from 'BaseView';

export default BaseView.extend({
	el: '#js_displayView',

	template: 'activity/inc/transactionDisplayMode',

	events: {
		'click .js_displayModeBtn': 'toggleMode'
	},

	initialize () {
		this.listenTo(this.model, 'change', this.render);
	},

	toggleMode (evt) {
		let selectedDisplayMode = evt.currentTarget.value;
		this.model.toggleMode(selectedDisplayMode);
	}
});



// WEBPACK FOOTER //
// ./view/activity/displayView.es6